module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/6-9b35adf2b36cb05dac0fcea33d5b9ee7.png";